const AnimationUtils 		= require('../90_utils/AnimationUtils');
const BrowserUtils 			= require('../90_utils/BrowserUtils');
const DOMUtils 				= require('../90_utils/DOMUtils');
const NumberUtils 			= require('../90_utils/NumberUtils');
const PositioningUtils 		= require('../90_utils/PositioningUtils');
const Loader 				= require('../90_utils/Loader');

const AnimationFrame		= require('./animation-frame');
const Breakpoint 			= require('./breakpoint');
const DomScan 				= require('./dom-scan');
const Router 				= require('./router');
const ScrollAnimations 		= require('./scroll-animations');

// const RenderEngine 	    	= require('../80_bits/render-engine/script');
const SiteController 		= require('../40_controllers/site-controller/script');

require('./polyfill.js');

(function($){

	/* jshint devel:true */
	'use strict';

	// global var buckets (public)

	window.SETTINGS = {};

	// internal vars

	let $window     = $(window);
	let	$body       = $(document.body);
	let	$html       = $(document.documentElement);
	let $main 		= $('#main');

	let	WS          = window.SETTINGS;

	// templates

	WS.templates = {
		content : [
			{ id: 'intro' },
			{ id: 'vision' },
			{
				id: 'action',
				sections: [
					{ id: 'reliable-energy' },
					{ id: 'cleaner-energy' },
					{ id: 'powerful-partnerships' },
					{ id: 'personalized-energy' },
					{ id: 'our-people' },
					{ id: 'positive-nrg' }
				]
			},
			{ id: 'impact' }
		],
		heroes : [
			{ id: 'intro' },
			{ id: 'vision' },
			{
				id: 'action',
				sections: [
					{ id: 'reliable-energy' },
					{ id: 'cleaner-energy' },
					{ id: 'powerful-partnerships' },
					{ id: 'personalized-energy' },
					{ id: 'our-people' },
					{ id: 'positive-nrg' }
				]
			},
			{ id: 'impact' }
		],
		modals : [
			{ id: 'downloads' },
			{ id: 'employer-brand-video' },
			{ id: 'index' },
			{ id: 'intro-video' },
			{ id: 'lobby-video' },
			{ id: 'mgm' },
			{ id: 'new-ideas' },
			{ id: 'petra-nova' },
			{ id: 'positive-nrg' },
			{ id: 'positive-nrg-video' },
			{ id: 'xprize-video' }
		]
	};

	// page / section associations

	WS.pageSections = {
		action: {
			title: 'NRG Year in Review - Action',
			sections: [
				{
					id: 'reliable-energy',
					title: 'Reliable Energy'
				},
				{
					id: 'cleaner-energy',
					title: 'Cleaner Energy'
				},
				{
					id: 'powerful-partnerships',
					title: 'Powerful Partnerships'
				},
				{
					id: 'personalized-energy',
					title: 'Personalized Energy'
				},
				{
					id: 'our-people',
					title: 'Our People'
				},
				{
					id: 'positive-nrg',
					title: 'positiveNRG'
				}
			]
		},
		impact: {
			title: 'NRG Year in Review - Impact',
			scrollSections: true,
			sections: [
				{
					id: 'numbers',
					title: '2016 By the Numbers'
				},
				{
					id: 'finances',
					title: 'Our Financial Strength'
				},
				{
					id: 'portfolio',
					title: 'A Leading Portfolio'
				},
				{
					id: 'growth',
					title: 'Renewable Footprint Growth'
				},
				{
					id: 'service',
					title: 'Award-Winning Service'
				},
				{
					id: 'community',
					title: 'A Generous Community'
				}
			]
		},
		intro: {
			title: 'NRG Year in Review - Intro'
		},
		vision: {
			title: 'NRG Year in Review - Vision',
			scrollSections: true,
			sections: [
				{
					id: 'ceo-introduction',
					title: 'CEO Bio'
				},
				{
					id: 'vision-mission',
					title: 'Vision / Mission'
				}
			]
		}
	}

	// global coords

	WS.coords = {
		containerWidth: 1920
	};

	// breakpoint detection

	WS.breakpoint = new Breakpoint({

		breakpoints: [
			{
				id: 'screen-tiny',
				value: 480
			},
			{
				id: 'screen-phablet',
				value: 640
			},
			{
				id: 'screen-small',
				value: 768
			},
			{
				id: 'screen-medium',
				value: 1024
			},
			{
				id: 'screen-large',
				value: 1280
			},
			{
				id: 'screen-xlarge',
				value: 1480
			},
			{
				id: 'screen-xxlarge',
				value: 1600
			},
			{
				id: 'screen-xxlarge',
				value: 1920
			}
		]
	});

	// paths

	WS.paths = {
		root 	: window.location.origin + ''
	}

	// modals

	WS.modals = {};

	// global variables (use sparingly)

	WS.vars = {
		svgIndex: 0
	};

	// global dom elements

	WS.elems            = {};
	WS.elems.html       = $('html');
	WS.elems.body       = $('body');

	// utility classes

	WS.domScan 			= new DomScan();
	WS.animationFrame	= new AnimationFrame();

	// animation settings

	WS.animation 		= {};
	WS.frameInterval 	= 160;
	WS.maxShakes 		= 16;

	// SimpleAnchors

	$.simpleAnchors({
		offset: -1, // 80-1, header height on scroll
		easing: 'easeInOutCubic'
	});

	// super duper throttled window resize event listener

	WS.coords.getDocHeight = () => {
		return $main.outerHeight();
	}

	let updateWinCoords = () => {
		WS.coords.winWidth			= window.innerWidth;
		WS.coords.winHeight			= window.innerHeight;
		WS.coords.docWidth			= $main.outerWidth();
		WS.coords.docHeight			= $main.outerHeight();
		WS.coords.viewportWidth		= Math.min(WS.coords.containerWidth, WS.coords.winWidth);
		WS.coords.scrollbarWidth	= Math.abs(WS.coords.winWidth - WS.coords.docWidth);
	}

	updateWinCoords();

	// let triggerResizeEvent = ((e) => {
	// 	updateWinCoords();
	// 	window.vent.trigger('windowResize', {originalEvent:e});
	// });

	// let resizeThrottler = _.throttle(triggerResizeEvent, 400);

	// $window.on('resize', resizeThrottler);
	// $window.on('orientationchange', resizeThrottler);
	// $window.on('load', resizeThrottler);

	// window.requestAnimationFrame(resizeThrottler);

	// global mouse coords

	$body.on('mousemove', (e) => {

		WS.coords.pageX = e.pageX;
		WS.coords.pageY = e.pageY;
		WS.coords.clientX = e.clientX;
		WS.coords.clientY = e.clientY;

		window.vent.trigger('mousemove', {
			originalEvent: e,
			pageX: WS.coords.pageX,
			pageY: WS.coords.pageY,
			clientX: WS.coords.clientX,
			clientY: WS.coords.clientY
		});
	});

	// initialize site

	if($('#main').length){

		WS.controllers = {}
		WS.controllers.site = new SiteController($('#main'), {});

		WS.router = new Router();
	}

	WS._scrollAnimations = new ScrollAnimations();

	//

	window.vent.trigger('domUpdate');
	// window.RENGINE = new RenderEngine();

	//

	let onResize = (e) => {

		updateWinCoords();
		window.vent.trigger('windowResize', {originalEvent:e});

		if(window.SETTINGS.breakpoint.maxWidth('screen-small')){
			// window.RENGINE.pause();
		}
		else {
			// window.RENGINE.unpause();
		}
	};

	$window.on('resize', onResize);
	$window.on('orientationchange', onResize);
	$window.on('load', onResize);

	window.requestAnimationFrame(() => {
		FastClick.attach(document.body);
		onResize();
	});

})(window.jQuery);
